<template>
  <div class="news">
    <Header active="news"></Header>
      <el-row class="banner" type="flex" align="middle">
          <el-col :span="2"></el-col>
          <el-col :span="4">
              <span class="business-title">新闻中心</span>
          </el-col>
      </el-row>

      <el-row class="spacing-up">
          <h1>企业新闻动态</h1>
      </el-row>

      <el-row v-for="(item, index) in list" v-bind:key="item.id" class="news-item" v-bind:class="{'news-item-bg': (index + 1) % 2 !== 0}" type="flex" align="middle">
          <el-col :span="12" v-bind:class="{'business-text': (index + 1) % 2 === 0}">

              <el-row v-if="(index + 1) % 2 !== 0">
                  <img :src="item.image" class="business-img" />
              </el-row>

              <el-row v-if="(index + 1) % 2 === 0" class="news-item-text-left">
                  <el-row>
                      <el-col :span="16" @click.native="toInfo(item.id)">
                          <h2 class="news-title">{{item.title}}</h2>
                      </el-col>
                      <el-col :span="8" class="news-time">{{convertTime(item.createTime)}}</el-col>
                  </el-row>
                  <p class="news-summary">
                      {{item.summary}}
                  </p>
                  <MainButton class="right" @click.native="toInfo(item.id)">详细信息</MainButton>
              </el-row>

          </el-col>
          <el-col :span="12" v-bind:class="{'business-text': (index + 1) % 2 !== 0}">
              <el-row v-if="(index + 1) % 2 !== 0" class="news-item-text-right">
                  <el-row>
                      <el-col :span="16" @click.native="toInfo(item.id)">
                          <h2 class="news-title">{{item.title}}</h2>
                      </el-col>
                      <el-col :span="8" class="news-time">{{convertTime(item.createTime)}}</el-col>
                  </el-row>
                  <p class="news-summary">
                      {{item.summary}}
                  </p>
                  <MainButton class="right" @click.native="toInfo(item.id)">详细信息</MainButton>
              </el-row>

              <el-row v-if="(index + 1) % 2 === 0">
                  <img :src="item.image" class="business-img" />
              </el-row>
          </el-col>
      </el-row>

      <el-row class="page-container">
          <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="page"
                  :page-count="totalPage"
                  @current-change="pageChange">
          </el-pagination>
      </el-row>

      <!--<el-row class="spacing-up">-->
          <!--<h1>党建专题</h1>-->
      <!--</el-row>-->

      <!--<el-row class="dangjian-bg">-->
          <!--<div class="corner"></div>-->
          <!--&lt;!&ndash;<img class="dangjian-bg" src="../assets/imgs/dangjian/job_bg.jpg" />&ndash;&gt;-->
      <!--</el-row>-->

      <!--<el-row class="dangjian-container">-->
          <!--<el-row class="dangjian-item" v-for="item in dangjianList" :key="item.id" @click.native="toDangjianInfo(item.id)">-->
              <!--<el-col :span="20" class="dangjian-title">-->
                  <!--{{item.title}}-->
              <!--</el-col>-->
              <!--<el-col :span="4" class="right dangjian-time">-->
                  <!--{{convertTime(item.createTime)}}-->
              <!--</el-col>-->
          <!--</el-row>-->
          <!--<el-row>-->
              <!--<MainButton class="right" @click.native="toDangjian">查看更多</MainButton>-->
          <!--</el-row>-->
      <!--</el-row>-->
      <Footer></Footer>
  </div>
</template>
<script>
    import Header from '../../components/Header.vue'
    import Footer from '../../components/Footer.vue'
    import MainButton from "../../components/MainButton";
    import {newsApi} from "../../api/news-api";
    import {formatFromTimeString} from "../../utils/date";

    export default {
        name: 'News',
        components: {MainButton, Header, Footer},
        data () {
            return {
                page: 1,
                limit: 5,
                totalPage: 1,
                list: [],
                finished: false,
                dangjianList: []
            }
        },
        mounted () {
          this.listNews();
          this.listDangjian();
        },
        methods: {
            listNews () {
                newsApi.list({
                    type: 1,
                    status: 1,
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.code === 200) {
                        this.totalPage = res.page.totalPage;
                        if (this.page >= res.page.totalPage) {
                            this.finished = true;
                        }
                        this.list = res.page.list;
                    }
                })
            },
            listDangjian () {
                newsApi.list({
                    type: 3,
                    status: 1,
                    page: 1,
                    limit: 3
                }).then(res => {
                    if (res.code === 200) {
                        this.dangjianList = res.page.list;
                    }
                })
            },
            pageChange (page) {
                this.page = page;
                this.listNews();
            },
            toInfo (id) {
                this.$router.push({
                    path: `/news/${id}`
                });
            },
            toDangjian () {
                this.$router.push({
                    path: `/dangjian`
                });
            },
            toDangjianInfo (id) {
                this.$router.push({
                    path: `/dangjian/${id}`
                });
            }
        },
        computed: {
            convertTime () {
                return function (time) {
                    return formatFromTimeString(time);
                }
            }
        }
    }
</script>
<style scoped>
    .news {
        height: 100%;
        width: 100%;
    }
    .banner {
        height: 300px;
        width: 100%;
        background: url("../../assets/imgs/news/newbanner.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .business-title {
        font-size: 36px;
        color: #ffffff;
        margin-top: 100px;
    }

    .business-text {
        font-size: 16px;
        text-align: left;
        padding-left: 60px;
        line-height: 30px;
        color: #505050;
    }

    .business-img {
        /*width: 500px;*/
        /*height: 200px;*/
        width: 60%;
        max-height: 280px;
    }

    .news-item-bg {
        background: #f0f0f0;
    }

    .news-item-text-right {
        padding-right: 80px;
    }


    .news-item-text-left {
        padding-left: 80px;
    }

    .news-time {
        text-align: right;
        height: 70px;
        line-height: 70px;
        font-size: 13px;
    }
    .news-title {
        cursor: pointer;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient:vertical;
    }




    .right {
        float: right;
    }

    .news-item {
        width: 100%;
        height: 300px;
    }

    .news-item:hover .news-title {
        color: #ff4e00;
    }

    .news-item-img {
        width: 100%;
        height: 100%;
    }

    .page-container {
        margin: 80px 0;
    }

    .dangjian-img {
        width: 100%;
        height: auto;
    }


    .dangjian-bg {
        background: url("../../assets/imgs/dangjian/party_bg.jpg") no-repeat;
        background-size: 100%;
        height: 300px;
    }

    .corner {
        width: 0;
        height: 0;
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-top: 30px solid #ffffff;
        z-index: 100;
        position: relative;
        margin: 0 auto;
    }

    .dangjian-container {
        padding: 60px 30%;
        text-align: left;
        margin-bottom: 60px;
    }

    .dangjian-title {
        font-size: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .dangjian-time {
        font-size: 14px;
        color: #777777;
        text-align: right;
    }
    .dangjian-item {
        margin-bottom: 15px;
        cursor: pointer;
    }

    .dangjian-item:hover .dangjian-title {
        color: #ff4e00;
    }

    .dangjian-item:hover .dangjian-time {
        color: #ff4e00;
    }

    .news-summary {
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient:vertical;
    }

    .spacing-up {
        margin-top: 60px;
        margin-bottom: 20px;
    }



</style>
